import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({ 
  providedIn: 'root' 
})
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsights.connectionString,
      }
    });
    this.appInsights.loadAppInsights();

    this.appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags['ai.cloud.role'] = 'Genesis-Self-Service';
  });
  }

  logPageView(name: string, url?: string, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) 
  {
    if (!environment.production) console.log('logPageView', name, url, properties, measurements);
    this.appInsights.trackPageView({ name, uri: url, properties, measurements });
  }

  logEvent(name: string, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) 
  {
    if (!environment.production) console.log('logEvent', name, properties, measurements);
    this.appInsights.trackEvent({ name }, { ...properties, ...measurements });
  }

  logException(exception: Error, severityLevel?: number, properties?: { [key: string]: any }) 
  {
    if (!environment.production) console.log('logException', exception, severityLevel, properties);
    this.appInsights.trackException({ exception, severityLevel, properties });
  }
}

export enum ApplicationInsightsEvent {
  OPEN, // When dialogs or new screens are opened
  GET, // API GET requests
  POST, // API POST requests
  PUT, // API PUT requests
  DELETE, // API DELETE requests
  ERROR, // Errors encountered for internal functions
  GET_ERROR, // Errors encountered after GET Http request
  POST_ERROR, // Errors encountered after POST Http request
  PUT_ERROR, // Errors encountered after PUT Http request
  DELETE_ERROR, // Errors encountered after DELETE Http request
  EXPORT, // When exporting data to external documents (PDF, CSV, etc)
  NAVIGATE // When navigating to link external to the application
}

export interface ApplicationInsightsProperties {
  user_id: string,
  event: string
}